<template>
  <div>
    <v-row>
        <v-col v-for="(p,index) in products" :key="index" lg="3" md="4">
            <v-card class="mx-auto" hover>
                <v-img :src="processImage(p.productImg)"></v-img>
                <v-card-title style="word-break:break-word;">{{ p.productName }}</v-card-title>
                <v-card-text class="py-0">{{ p.productDetails }}</v-card-text>
                <v-card-text class="primary--text py-2">{{ $n(p.productPrice, 'currency') }}</v-card-text>

                <v-card-actions class="py-0">
                    <v-list-item class="grow">
                        <v-list-item-avatar color="grey darken-3" size="25">
                            <v-img class="elevation-6" :src="sellerIcon"></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content class="text-caption">
                            {{ sellerName }}
                        </v-list-item-content>
                        <v-row align="center" justify="end">
                            <v-icon @click="viewDetails(p.productId)" class="mr-2" color="grey darken-1">mdi-cube-scan</v-icon>
                            <v-icon @click="addCart(p)" class="mr-1" color="primary lighten-2">mdi-shopping-outline</v-icon>
                        </v-row>
                    </v-list-item>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
  </div>
</template>

<script>
import { processImage } from '../../utils/product';

export default {
    props: ['products'],
    data() {
        return {
            sellerIcon: "https://avataaars.io/?avatarStyle=Transparent&topType=LongHairNotTooLong&accessoriesType=Blank&hairColor=Black&facialHairType=BeardMedium&facialHairColor=BrownDark&clotheType=BlazerShirt&eyeType=Default&eyebrowType=Angry&mouthType=Sad&skinColor=Pale",
            sellerName: "One Official"
        }
    },
    methods: {
        processImage,
        viewDetails(pId) {
            this.$router.push({ path: `/items/${pId}` });
        },
        addCart(item) {
            if(this.$store.getters['isLoggedIn']) {
                var params = { pId: item.productId, pQty: 1 };
                this.$store.dispatch('addItemToCart', params);
                this.$store.dispatch('getCartList');
                
                this.$toast({
                    text: `Item [<span class='primary--text'> ${item.productName}</span> ] Added to cart`,
                    btnText: `${ this.$t('closeBtn') }`
                });
            } else {
                this.$toast({
                    text: `${ this.$t('cart.loginRequired') }`,
                    btnText: `${ this.$t('closeBtn') }`
                });
            }
        },

    }
}
</script>
